<mat-form-field id="language-selector">
  <mat-label>Idioma</mat-label>
  <mat-select [formControl]="languageSelector">
    <mat-option *ngFor="let language of languages" [value]="language">
      {{ language }}
    </mat-option>
  </mat-select>
</mat-form-field>
